import { render } from "./CompaniesPage.vue?vue&type=template&id=347703ce&ts=true"
import script from "./CompaniesPage.vue?vue&type=script&lang=ts"
export * from "./CompaniesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__